import { render, staticRenderFns } from "./BaseSubNav.vue?vue&type=template&id=a32d6f80&scoped=true&lang=pug"
import script from "./BaseSubNav.vue?vue&type=script&lang=js"
export * from "./BaseSubNav.vue?vue&type=script&lang=js"
import style0 from "./BaseSubNav.vue?vue&type=style&index=0&id=a32d6f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32d6f80",
  null
  
)

export default component.exports